/**
 * Save the scroll position in the session storage
 */
export function preserveScrollBeforeNavigation() {
  sessionStorage.setItem("scrollPosition", window.scrollY);
}
/**
 * Restore the scroll
 */
export function restoreScrollAfterNavigation() {
  const saved = sessionStorage.getItem("scrollPosition");
  if (saved) {
    window.scrollTo(0, parseInt(saved, 10));
    sessionStorage.removeItem("scrollPosition");
  }
}
